import map from 'lodash/map';
import DELIVERABLES_EXECUTION_STATUS from 'components/Deliverable/constants/deliverablesExecutionStatus';

export const DELIVERABLE_SORT_OPTIONS = [
  {
    name: 'propertyName',
    label: 'Property Name',
    from: 'A',
    to: 'Z',
    defaultDirection: 'asc',
  },
  {
    name: 'created',
    label: 'Created Date',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'desc',
  },
  {
    name: 'updated',
    label: 'Last Edited',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'desc',
  },
  {
    name: 'status',
    label: 'Status',
    from: 'Approval',
    to: 'Released',
    defaultDirection: 'asc',
  },
  {
    name: 'paymentDueDate',
    label: 'Payment Due Date',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'desc',
    requiresPrivilegedControls: true,
  },
  {
    name: 'paymentStatus',
    label: 'Payment Status',
    from: 'A',
    to: 'Z',
    defaultDirection: 'asc',
    requiresPrivilegedControls: true,
  },
  {
    name: 'paymentType',
    label: 'Payment Type',
    from: 'A',
    to: 'Z',
    defaultDirection: 'asc',
    requiresPrivilegedControls: true,
  },
  {
    name: 'likesCount',
    label: 'Likes Count',
    from: 'Less',
    to: 'More',
    defaultDirection: 'asc',
    requiresPrivilegedControls: true,
  },
  {
    name: 'contentIqScore',
    label: 'Content IQ Score',
    from: 'Low',
    to: 'High',
    defaultDirection: 'desc',
    requiresContentIq: true,
  },
  {
    name: 'airDateFrom',
    label: 'Air Date',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'desc',
    requiresPrivilegedControls: true,
  },
];

export const DELIVERABLE_GROUP_BY_OPTIONS = [
  {
    value: 'production',
    label: 'Production',
  },
];

export const DELIVERABLES_TYPES = ['production driven', 'paid integration'];
export const DELIVERABLES_TYPES_SELECT_OPTIONS = [
  { value: 'PRODUCTION_DRIVEN', label: 'Production Driven' },
  { value: 'PAID_INTEGRATION', label: 'Paid Integration' },
];

export const DELIVERABLES_TYPES_INITIALS = {
  PRODUCTION_DRIVEN: 'PD',
  PAID_INTEGRATION: 'PP',
};

export const DELIVERABLES_METRICS_TYPES = ['impressions', 'views'];
export const DELIVERABLES_METRICS_UNIT_TYPES = {
  impressions: 'CPM',
  views: 'CPV',
};

export const DELIVERABLE_EXECUTION_PHASES = {
  list: 'List',
  planning: 'Planning',
  pending: 'Pending',
  confirmed: 'Confirmed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const DELIVERABLES_REV_REC_OPTIONS = [
  { name: 'High', id: 'high' },
  { name: 'Med', id: 'med' },
  { name: 'Low', id: 'low' },
  { name: 'Value Actual', id: 'valueActual' },
  { name: 'Reallocate', id: 'reallocate' },
  { name: 'Credit Needed', id: 'creditNeeded' },
];

export const DELIVERABLES_EXECUTION_STATUS_SELECT_OPTIONS = map(
  DELIVERABLES_EXECUTION_STATUS,
  (status, key) => ({
    phase: status.phase,
    name: key,
  }),
);

export const DELIVERABLES_EXECUTION_STATUS_REJECTED_SELECT_OPTIONS = map(
  DELIVERABLES_EXECUTION_STATUS,
  (status, key) => ({
    phase: status.phase,
    name: key,
  }),
).filter(
  (option) => option.phase === 'rejected' || option.name === 'listRejected',
);

export const DELIVERABLES_ADVANCED_FILTERS = [];

export const FILTERS_FORM_ID = 'deliverableList';

export const SINGLE_VIEW_FIELDS_STORAGE_KEY = '$BEN$--deliverablesSearchFilter';

export const DELIVERABLES_SEARCH_LIMIT = 24;

export const DELIVERABLES_PAYMENT_STATUS_OPTIONS = [
  {
    label: 'Paid',
    value: 'paid',
  },
  {
    label: 'Unpaid',
    value: 'unpaid',
  },
  {
    label: 'Pending/Open',
    value: 'pendingOpen',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
  },
  {
    label: 'Unclaimed-Paypal',
    value: 'unclaimedPaypal',
  },
  {
    label: 'Completed-Paypal',
    value: 'completedPaypal',
  },
  {
    label: 'Ready for Payment',
    value: 'readyForPayment',
  },
];

export const DELIVERABLES_PAYMENT_TYPE_OPTIONS = [
  {
    label: 'PayPal',
    value: 'paypal',
  },
  {
    label: 'ACH/Wire',
    value: 'achWire',
  },
  {
    label: 'Check',
    value: 'check',
  },
];

/**
 * Order of this array matters. Do not change!
 */
export const DELIVERABLES_STATUS_NAMES = [
  'forReview',
  'listApproved',
  'listRejected',
  'activeTarget',
  'reachedOut',
  'responded',
  'sentProduct',
  'offerExtended',
  'inNegotiation',
  'offerAccepted',
  'ndaSent',
  'delayed',
  'notApplicable',
  'contractOut',
  'contractSigned',
  'contentDraft',
  'approved',
  'sceneShot',
  'receivedPOP',
  'liveReleased',
  'sentForPayment',
  'incomplete',
  'noResponse',
  'timing',
  'budget',
  'notInterested',
  'benRejected',
  'clientRejected',
  'productionRejected',
  'noExposure',
];

export const typeLabels = {
  PAID_INTEGRATION: 'Paid integration',
  PRODUCTION_DRIVEN: 'Production Driven',
};

export const DELIVERABLES_BUNDLE_STATUSES = [
  'Bundle Hidden',
  'Bundle Open',
  'Bundle Even',
];

export const DELIVERABLES_BUNDLE_STATUSES_OPTIONS = DELIVERABLES_BUNDLE_STATUSES.map(
  (status) => ({
    value: status,
    label: status,
  }),
);

export const DELIVERABLES_PRODUCT_STATUSES = [
  'Needs to Order',
  'Address Needed',
  'Ordered',
  'In Transit',
  'Delivered',
  'Code Sent',
  'Code Made',
  'Ready',
  'Order Delayed',
  'Technical Issues',
];

export const DELIVERABLES_PRODUCT_STATUSES_OPTIONS = DELIVERABLES_PRODUCT_STATUSES.map(
  (status) => ({
    value: status,
    label: status,
  }),
);
